<template>
  <div>
    <DataTable :headers="headers" :path="path" :properties="properties" :filterPath="filterPath" filter ref="datatable"
               slot-name="second-last-column" action-buttons-name="ReportContractsDetailActionButtons">
        <span slot="after-filters">
            <v-tooltip bottom>
                <v-btn slot="activator" icon @click="sendExcel" flat>
                    <v-icon color="primary">far fa-file-excel</v-icon>
                </v-btn>
                <span>Descargar XLS</span>
            </v-tooltip>
        </span>
    </DataTable>
    <v-snackbar v-model="sendEmailAlert" auto-height color="error">
      <span>En unos minutos recibirá el reporte a su correo electrónico</span>
      <v-btn icon @click="sendEmailAlert = false"><v-icon>close</v-icon></v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import DataTable from '../../../common/ui/DataTable'
import { downloadFileMixin } from '../../../mixins/downloadFileMixin'
import { paginationMixin } from '../../../mixins/paginationMixin'

export default {
  mixins: [downloadFileMixin, paginationMixin],

  components: {
    DataTable
  },

  data () {
    return {
      headers: [
        { text: 'Club', value: 'club', sortable: true, filterField: true },
        { text: 'Apellido', value: 'last_name', sortable: false },
        { text: 'Nombre', value: 'first_name', sortable: false },
        { text: 'DNI', value: 'dni', sortable: false },
        { text: 'Pasaporte', value: 'pasaporte', sortable: false },
        { text: 'Fecha Nacimiento', value: 'birth_day', sortable: false },
        { text: 'Edad', value: 'age', sortable: false },
        { text: 'Estado CT', value: 'player_status', visible: true },
        { text: 'Tipo de contrato', value: 'contract_type', filterField: true },
        { text: 'Inicio de contrato', value: 'start_date' },
        { text: 'Fin de contrato', value: 'end_date' },
        { text: 'Desde inicio de contrato ', value: 'fromDate', sortable: false, dateFilterField: true, visible: false },
        { text: 'Hasta inicio de contrato', value: 'toDate', sortable: false, dateFilterField: true, visible: false },
        { text: 'Estado del contrato', value: 'status', filterField: true, visible: true },
        { text: 'Última actualización', value: 'modified', sortable: false },
        { text: 'Acciones', align: 'right', sortable: false }

      ],
      properties: ['club', 'playerLastName', 'playerFirstName', 'dni', 'pasaporte', 'birthDay', 'age', 'playerStatus', 'contractType', 'startDate', 'endDate', 'status', 'modified'],
      path: 'contratos-detail/cuerpo-tecnico/list',
      filterPath: 'filters/contract-cuerpo-tecnico-detail',
      sendEmailAlert: false
    }
  },

  methods: {
    noContracts (item) {
      return (item.verified + item.pending + item.rejected + item.ended) === 0
    },
    getExcelPath () {
      return 'contratos-detail/cuerpo-tecnico/xls' + '?' + this.$refs.datatable.getFilteringPath().substring(1)
    },
    getFilenamePrefix () {
      return 'contratos'
    },
    sendExcel () {
      this.axios
        .get(this.getExcelPath())
        .then((response) => {
          this.sendEmailAlert = true
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    }
  }
}

</script>

<style scoped>
    .table-row {
        background-color: white;
        border-bottom: 1px solid #959ba6;
    }
    .table-row-no-contracts {
        background-color: #d0caca;
        border-bottom: 1px solid #959ba6;
    }
</style>
